





































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import ImageSwiper from './ImageSwiper.vue';
// 该页面中的 Trajectory 组件并未用到 注释相关引用调用代码
// import Trajectory from '@/components/Trajectory.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
import { enums } from '@/common/enums';
import { WayBill,ExpenseType } from '@/http';
import DivSwiper from './divSwiper.vue';
import { upload } from '@/common/util/ossUploadService';
import validator, { formRules } from '@/common/util/validator';
import BaseInfoPanelWithBadge from '@/components/BaseInfoPanelWithBadge.vue';
import publicFunc from '../../../../common/util/publicFunc';
@Component({
    components: {
        ImageSwiper,
        // Trajectory,
        BaseInfoPanel,
        BaseInfoPanelWithBadge,
        DivSwiper,
    },
})
export default class WayBillInfo extends Vue {
    @Prop()
    public detailData: any;
    public status: any = '';
    public publicFunc: any = publicFunc;
    public goodsUnit = enums.goodsUnitType;
    public wayBillHasDoneType = enums.wayBillHasDoneType;
    public activities: any = [];
    bgclDialog: boolean = false;
    bgysxxDialog: boolean = false;
    public formRules = formRules;
    public carLengthType = enums.carLengthType;
    public carType = enums.carType;
    @Prop()
    public fee: any;
    bgcl: any = {
        id: '',
        carId: 0,
        carCode: '',
        driverId: 0,
        driverName: '',
        driverPhone: '',
        carLengthEnum: '',
        carLengthEnumStr: '',
        vehicleTypeEnum: '',
        vehicleTypeEnumStr: '',
        carrierAttList: [],
    };
    public planWeightForm: any = {
        totalRealQuantity:''
    }
    editCys() {
        this.bgclDialog = true;
        // this.bgcl.id = this.detailData.id;
        // this.bgcl.carId = this.detailData.carId;
        // this.bgcl.carCode = this.detailData.carCode;
        // this.bgcl.driverId = this.detailData.driverId;
        // this.bgcl.driverName = this.detailData.driverName;
        // this.bgcl.driverPhone = this.detailData.driverPhone;
        // this.bgcl.carLengthEnum = this.detailData.carLengthEnum;
        // this.bgcl.vehicleTypeEnum = this.detailData.vehicleTypeEnum;
        // this.bgcl.carrierAttList = this.detailData.carrierAttList;
    }
    tocys() {
        this.$refs['cysForm']['validate']((valid) => {
            if (valid) {
                console.log('goto 变更承运商', this.bgcl);
                let pics = this.detailData.carrierAttList.map((item) => {
                    return { name: item.name, url: item.url };
                });
                WayBill.changeCys({
                    id: this.detailData.id,
                    carId: this.detailData.carId,
                    carCode: this.detailData.carCode,
                    driverId: this.detailData.driverId,
                    driverName: this.detailData.driverName,
                    carLengthEnum: this.detailData.carLengthEnum,
                    vehicleTypeEnum: this.detailData.vehicleTypeEnum,
                    carrierAttList: pics,
                }).then((res) => {
                    this.$message.warning('运力信息修改成功!');
                    this.bgclDialog = false;
                });
            }
        });
    }
    bgyl() {
        this.bgysxxDialog = true;
        //this.sd.sdDate = this.formatDate(new Date());
    }

    tobgcl() {
        (this.$refs['bgclForm'] as any)['validate']((valid) => {
            if (valid) {
                console.log('goto 变更车辆', this.bgcl);
                let pics = this.detailData.carrierAttList.map((item) => {
                    return { name: item.name, url: item.url };
                });
                WayBill.changeYsxx({
                    id: this.detailData.id,
                    realDeliveryTime: this.detailData.realDeliveryTime,
                    realArrivalTime: this.detailData.realArrivalTime,
                    deliveryAttList: this.detailData.deliveryAttList,
                    arrivalAttList: this.detailData.arrivalAttList,
                }).then((res) => {
                    this.$message.warning('运输信息修改成功!');
                    this.bgysxxDialog = false;
                });
            }
        });
    }
    public fhyz3: boolean = false;
    public showmap:boolean = false;
    public showyf:boolean = false;

    addfreeDialog: boolean = false;
    addfree: any = {
        jjfs: '线路-车长', //计价方式
        danj: '', //单价
        count: 1, //数量
        dw: '3', //数量单位
        feeType: '', //费用类型
        feeAmount: '', //费用金额
        feeExplain: '', //费用说明
        carrierOrderCode: '',
        id:''
    };
    //a:应付费用登记 b:应收费用登记
    feeType:any = '';
    //add:新增 edit:编辑
    actionType:any = '';
    selectionRow:any = {};
    title:any = '';

     /**
     * 获取费用类型
     */
    public feeTypeList = [];
    public async GetfeeTypeList() {
        await ExpenseType.GetList({
            isEnable: true,
            skip: -1,
            count: -1,
        }).then((res) => {
            this.feeTypeList = res.data;
            console.log('费用类型-->',res);
        });
    }
    clickAddFree(feeType,actionType,value) {
        console.log('freee-->',value);
        this.feeType = feeType;
        this.actionType = actionType;
        this.selectionRow = value;
        this.GetfeeTypeList();
        if(this.feeType == 'a' && this.actionType == 'add'){
            this.title = '新增应付费用';
            this.addfree.carrierOrderCode = this.detailData.carrierOrderCode;
        }else if(this.feeType == 'b' && this.actionType == 'add'){
            this.title = '新增应收费用';
            this.addfree.carrierOrderCode = this.detailData.carrierOrderCode;
        }else if(this.feeType == 'a' && this.actionType == 'edit'){
            this.title = '编辑应付费用';
            console.log('应付费用-->',value);
            this.addfree.carrierOrderCode = this.detailData.carrierOrderCode;
            this.addfree.feeType = value.feeType;
            this.addfree.feeAmount = value.feeAmount;
            this.addfree.feeExplain = value.feeExplain;
            this.addfree.id = value.id;
            this.addfreeDialog = true;            
            //(this.$refs['freeForm'] as any).resetFields();
        }else if(this.feeType == 'b' && this.actionType == 'edit'){
            this.title = '编辑应收费用';
            console.log('应收费用-->',value);
            this.addfree.id = value.id;
            this.addfree.carrierOrderCode = this.detailData.carrierOrderCode;
            this.addfree.feeType = value.expenseType;
            this.addfree.feeAmount = value.amount;
            this.addfree.feeExplain = value.expenseExplain;
            this.addfreeDialog = true;
            //(this.$refs['freeForm'] as any).resetFields();
        }        
        if (this.actionType == 'add') {
            //let row = this.selectionRow[0];

            // if (row.carrierOrderStatus != 2) {
            //     return this.$message.warning('只有在途中的运单可添加费用!');
            // }
            
            
            
            // this.addfree.carrierOrderCode = this.selectionRow[0].carrierOrderCode;
            // console.log('select--row', row);
            // PriceList.GetxlyPrice({
            //     priceListType: 1,
            //     deliveryProvince: row.orderList[0].originProvince,
            //     deliveryCity: row.orderList[0].originCity,
            //     deliveryArea: row.orderList[0].originCounty,
            //     arrivalProvince: row.orderList[0].arrivalProvince,
            //     arrivalCity: row.orderList[0].arrivalCity,
            //     arrivalArea: row.orderList[0].arrivalCounty,
            //     titleName: row.carLengthEnumStr ? row.carLengthEnumStr : row.vehicleTypeEnumStr,
            // }).then((res) => {
            //     console.log('getprice', res);
            //     this.addfree.danj = res.extData;
            //     //this.addfree.danj = 100;
            //     if (this.addfree.danj) {
            //         this.addfree.count = 1;
            //     }
            //     this.addfreeDialog = true;
            //     this.$refs['freeForm'].resetFields();
            // });            
            
            this.addfreeDialog = true;
            (this.$refs['freeForm'] as any).resetFields();
            this.addfree.danj = '';
            this.addfree.count = '';
            this.addfree.feeType = '';
            this.addfree.feeAmount = '';
            this.addfree.feeExplain = '';
            this.addfree.carrierOrderCode = this.detailData.carrierOrderCode;
            
        }      
    }
    toaddfree() {
        this.$refs['freeForm']['validate']((valid) => {
            if (valid) {
                if(this.actionType == 'add'){
                    if(this.feeType == 'a'){
                        WayBill.addYf({
                            carrierOrderId: this.detailData.id,
                            feeType: this.addfree.feeType,
                            feeAmount: this.addfree.feeAmount,
                            feeExplain: this.addfree.feeExplain,
                        }).then(res=>{
                            this.addfreeDialog = false;
                            this.$message.warning('应付费用新增成功!');
                            WayBill.getyffeelist(this.detailData.id).then(res=>{
                                console.log('费用',res);
                                this.yffeelist = res.data;
                                this.yftotal = res.total;
                                this.totalyfAmount = res.totalAmount;
                            })
                        })
                    }else{
                        WayBill.addYs({
                            carrierOrderId: this.detailData.id,
                            expenseType: this.addfree.feeType,
                            amount: this.addfree.feeAmount,
                            expenseExplain: this.addfree.feeExplain,
                        }).then(res=>{
                            this.addfreeDialog = false;
                            this.$message.warning('应收费用新增成功!');
                            WayBill.getysfeelist(this.detailData.id).then(res=>{
                                console.log('费用',res);
                                this.ysfeelist = res.data;
                                this.ystotal = res.total;
                                this.totalysAmount = res.totalAmount;
                            })
                        })
                    }
                }else{
                    if(this.feeType == 'a'){
                        WayBill.editYf({
                            id:this.addfree.id,                            
                            feeType: this.addfree.feeType,
                            feeAmount: this.addfree.feeAmount,
                            feeExplain: this.addfree.feeExplain,
                        }).then(res=>{
                            this.addfreeDialog = false;
                            this.$message.warning('应付费用编辑成功!');
                            WayBill.getyffeelist(this.detailData.id).then(res=>{
                                console.log('费用',res);
                                this.yffeelist = res.data;
                                this.yftotal = res.total;
                                this.totalyfAmount = res.totalAmount;
                            })
                        })
                    }else{
                        WayBill.editYs(this.addfree.id,{
                            //id: this.addfree.id,
                            expenseType: this.addfree.feeType,
                            amount: this.addfree.feeAmount,
                            expenseExplain: this.addfree.feeExplain,
                        }).then(res=>{
                            this.addfreeDialog = false;
                            this.$message.warning('应收费用编辑成功!');
                            WayBill.getysfeelist(this.detailData.id).then(res=>{
                                console.log('费用',res);
                                this.ysfeelist = res.data;
                                this.ystotal = res.total;
                                this.totalysAmount = res.totalAmount;
                            })
                        })
                    }
                }
                
                console.log('goto 新增费用');
            }
        });
    }
    delfee(type,value){
        let id = value.id;
        if(type=='a'){

        }else{

        }
    }
    public ydyffyzk3:boolean = false;//应付查看
    public yffybjsc3:boolean = false;//应付编辑，删除
    public ydysfyzk3:boolean = false;//应收查看
    public ysfybjsc3:boolean = false;//应收编辑，删除    
    public ydgl2:boolean = false;//运单管理菜单
    public yffydj3:boolean = false;//应付登记
    public ysfydj3:boolean = false;//应收登记
    public zjyd3:boolean = false;//终结
    /**确认发货 */
    public ydqrfh3:boolean = false;

    created() {
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        this.fhyz3 = webMenus.includes('fhyz3');
        this.ydyffyzk3 = webMenus.includes('ydyffyzk3');
        this.yffybjsc3 = webMenus.includes('yffybjsc3');
        this.ydysfyzk3 = webMenus.includes('ydysfyzk3');
        this.ysfybjsc3 = webMenus.includes('ysfybjsc3');
        this.ydgl2 = webMenus.includes('ydgl2');
        this.yffydj3 = webMenus.includes('yffydj3');
        this.ysfydj3 = webMenus.includes('ysfydj3');
        this.zjyd3 = webMenus.includes('zjyd3');
        this.ydqrfh3 = webMenus.includes('ydqrfh3');
    }
    public yffeelist:any = [];
    public yftotal:any = 0;
    public ysfeelist:any = [];
    public ystotal:any = 0;

    public totalyfAmount:any = 0;
    public totalysAmount:any = 0;
    public mounted() {
        this.id = this.$route.query.orderId;
        this.detailData.receiptStatus = this.detailData.receiptStatus.toString();
        let skip =0;
        this.detailData.carrierOrderGoodsList = this.detailData.carrierOrderGoodsList.map((v) => {
            return { ...v, realGoodsUnit: v.realGoodsUnit ? v.realGoodsUnit.toString() : '',index:skip++ +1 };
        });
        this.status = this.detailData.carrierOrderStatus;
        if(this.status == 2 || this.status == 3) {
            WayBill.getyffeelist(this.detailData.id).then(res=>{
                console.log('费用',res);
                this.yffeelist = res.data;
                this.yftotal = res.total;
                this.totalyfAmount = res.totalAmount;
            })
            WayBill.getysfeelist(this.detailData.id).then(res=>{
                console.log('费用',res);
                this.ysfeelist = res.data;
                this.ystotal = res.total;
                this.totalysAmount = res.totalAmount;
            })
        }
    }
    public back() {
        if(!this.ydgl2){
            this.$router.back();
        }
        if (this.$route.query.types == 'ordermanager') {
            this.$router.push('/ordermanager');
            return;
        }
        if (this.$route.query.type == 'error') {
            this.$router.push('/errorManager');
            return;
        }
        if(this.$route.query.type == 'receipt'){
            this.$router.push('/receiptManager');
            return;
        }
        if (this.$route.query.types == 'orderDetailcc') {
            this.$router.push({
                path: '/orderDetailcc',
                query: {
                    id: this.$route.query.id,
                    name: 'detail',
                },
            });
            return;
        }
        if (this.fee) {
            switch (this.fee) {
                case '1':
                    this.$router.push('/payManagement');
                    break;
                case '2':
                    this.$router.push('/receivableManagement');
                    break;
                case '3':
                    this.$router.go(-1);
                    break;
                default:
                    break;
            }
        } else {
            this.$router.push('/WayBillManage');
        }
    }
    public async handleUpload(param, fileList) {
        console.log('toupload-->', param);
        const res = await upload(param.file, param.file.name);
        if (res.res.statusCode == '200') {
            let url = res.res.requestUrls[0].split('?')[0];
            console.log('chengggonel-->', param.file.name, url);
            this.detailData.carrierAttList.push({ name: param.file.name, url: url });
            //this.$emit('setImage', param.file.name, url, param.file.uid);
        } else {
            this.$message.warning('图片上传失败!');
        }
    }
    public beforeAvatarUpload(file) {
        let imgType = file.name.split('.').pop();
        let allowType = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];
        //console.log('type-->',file,imgType);
        if (allowType.indexOf(imgType.toLowerCase()) === -1) {
            this.$alert('不支持该文件类型').then((e) => {});
            return false;
        }
    }
    handleRemove(file, fileList) {
        // this.pics=this.pics.filter(v=>{
        //     return v.uid!=file.uid;
        // })
        if (this.detailData.carrierAttList.includes(file)) {
            this.detailData.carrierAttList.splice(this.detailData.carrierAttList.indexOf(file), 1);
        }
        //console.log(file, fileList);
    }
    public wayBill: any = {
        status: '1',
        pics: [],
    };
    fileList: any = [];
    onSuccess(file, fileList, ppp) {
        console.log('success==>', file, fileList, ppp);
    }
    public async handleUploadxc(param, file, fileList) {
        console.log('toupload-->', param, file, fileList);
        const res = await upload(param.file, param.file.name);
        if (res.res.statusCode == '200') {
            let url = res.res.requestUrls[0].split('?')[0];
            console.log('chengggonel-->', param.file.name, url, this.wayBill.pics);
            this.detailData.deliveryAttList.push({ url: url });
        } else {
            this.$message.warning('图片上传失败!');
        }
    }
    public beforeAvatarUploadxc(file) {
        let imgType = file.name.split('.').pop();
        let allowType = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];
        //console.log('type-->',file,imgType);
        if (allowType.indexOf(imgType.toLowerCase()) === -1) {
            this.$alert('不支持该文件类型').then((e) => {});
            return false;
        }
    }
    handleRemovexc(file, fileList) {
        if ((this.detailData.deliveryAttList as any).includes(file)) {
            this.detailData.deliveryAttList.splice(this.detailData.deliveryAttList.indexOf(file), 1);
        }
        console.log(file, fileList);
    }
    public async handleUploadsd(param, file, fileList) {
        console.log('toupload-->', param, file, fileList);
        const res = await upload(param.file, param.file.name);
        if (res.res.statusCode == '200') {
            let url = res.res.requestUrls[0].split('?')[0];
            console.log('chengggonel-->', param.file.name, url, this.wayBill.pics);
            this.detailData.arrivalAttList.push({ name: param.file.name, url: url });
        } else {
            this.$message.warning('图片上传失败!');
        }
    }
    public beforeAvatarUploadsd(file) {
        let imgType = file.name.split('.').pop();
        let allowType = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];
        //console.log('type-->',file,imgType);
        if (allowType.indexOf(imgType.toLowerCase()) === -1) {
            this.$alert('不支持该文件类型').then((e) => {});
            return false;
        }
    }
    handleRemovesd(file, fileList) {
        if ((this.detailData.arrivalAttList as any).includes(file)) {
            this.detailData.arrivalAttList.splice(this.detailData.arrivalAttList.indexOf(file), 1);
        }
        console.log(file, fileList);
    }
    public async handleUploadend(param, file, fileList) {
        console.log('toupload-->', param, file, fileList);
        const res = await upload(param.file, param.file.name);
        if (res.res.statusCode == '200') {
            let url = res.res.requestUrls[0].split('?')[0];
            console.log('chengggonel-->', param.file.name, url, this.wayBill.pics);
            this.detailData.receiptList.push({ url: url });
            //this.fileList = fileList;
            //this.wayBill.pics = fileList;
            //this.$emit('setImage', param.file.name, url, param.file.uid);
        } else {
            this.$message.warning('图片上传失败!');
        }
    }
    public beforeAvatarUploadend(file) {
        let imgType = file.name.split('.').pop();
        let allowType = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];
        //console.log('type-->',file,imgType);
        if (allowType.indexOf(imgType.toLowerCase()) === -1) {
            this.$alert('不支持该文件类型').then((e) => {});
            return false;
        }
    }
    handleRemoveend(file, fileList) {
        // const index = this.wayBill.pics.findIndex(item => item.uid === file.uid);
        // if ( index === -1) {
        //     this.$message.error('删除的文件未找到');
        //     return;
        // }
        // this.wayBill.pics.splice(index,1);
        if ((this.detailData.receiptList as any).includes(file)) {
            this.detailData.receiptList.splice(this.detailData.receiptList.indexOf(file), 1);
        }
        console.log(file, fileList);
    }

    public async DredgeLBS() {
        //this.locationSuc = '';
        WayBill.DredgeLBS({
            phone: this.detailData.driverPhone,
        })
            .then((res) => {
                console.log('开通lBS', res);
                this.$message.success(res.messageInfo);
                this.isRegister = res.isRegister;
            })
            .catch((err) => {
                // console.log('开通LBS异常',err);
                // this.$message.warning(err);
            });
    }
       // 删除
     public dialogConfig2 = {
        title: '',
        show: false,
    };
    confirmClose2() {
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }

    del() {
        this.dialogConfig2 = {
            title: '删除该运单',
            show: true,
        };
        // this.$confirm('确认删除该运单?', '运单删除', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // }).then((res) => {
        //     WayBill.delyd({ id: this.detailData.id }).then((res) => {
        //         console.log('end-->', res);
        //         // WayBill.isFee({ carrierOrderId: this.detailData.id }).then((res) => {
        //         this.$message.warning('运单删除成功!');
        //         this.$router.push('/WayBillManage');
        //         // });
        //     });
        // });
    }
    confirmOk2(){
           WayBill.delyd({ id: this.detailData.id }).then((res) => {
                console.log('end-->', res);
                // WayBill.isFee({ carrierOrderId: this.detailData.id }).then((res) => {
                this.$message.success('运单删除成功!');
                this.$router.push('/WayBillManage');
                // });
            });
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
            
    }
    public locData: any = {};
    public locationSuc: any = '';
    public positionType = 1;
    public async GetLocation(positionType) {
        //this.showLocationPanel = true;
        console.log('ddddddd');
        this.locationSuc = '';
        this.positionType = positionType;
        let res = await WayBill.getzndw({
            positionType: positionType,
            //phone: this.detailData.driverPhone,
            //carCode: this.detailData.carCode,
            carrierOrderId: this.detailData.id,
        });
        console.log('jfoiewf');
        if (positionType == 1) {
            if (res) {
                // let locations = await WayBill.getHistoryLocation({
                //      carrierOrderId: this.detailData.id,
                // });
                // console.log('lbs定位-->',locations);
                // this.locData = locations;
                //this.locData = res;
                //(this.$refs.Trajectory as any).setPoint(this.locData.longitude, this.locData.latitude, this.locData.area, this.locData.locationTime);
                // (this.$refs.Trajectory as any).setPoint(locations.data,this.detailData.carCode);
                this.initActivity();
                this.locationSuc = '定位成功';
                console.log(this.locData, res);
            } else {
                this.$message.warning('定位失败');
                this.locationSuc = '定位失败';
            }
        } else {
            if (res) {
                console.log('1111', res);
                // let locations = await WayBill.getHistoryLocation({
                //      positionType: positionType,
                //      phone: this.detailData.driverPhone,
                //      carCode: this.detailData.carCode,
                //      carrierOrderId: this.detailData.id,
                // });
                // console.log('北斗定位-->',locations);
                // this.locData = locations;
                //this.locData = res;
                console.log(this.locData, res);
                //(this.$refs.Trajectory as any).setPoint(this.locData.longitude, this.locData.latitude, this.locData.area, this.locData.locationTime);
                //(this.$refs.Trajectory as any).setPoint(locations.data,this.detailData.carCode);
                this.initActivity();
                this.locationSuc = '定位成功';
            } else {
                this.$message.warning('定位失败');
                this.locationSuc = '定位失败';
            }
        }
        //this.init();
    }
    public isRegister: boolean = false;
    public id: any = '';
    public data: any = {};
    public async initMap() {
        this.id = this.$route.query.id;
        let res = await WayBill.getLbsStatus({
            phone: this.detailData.driverPhone,
        });
        this.isRegister = res.isRegister;
        this.data = await WayBill.getHistoryLocation({
            carrierOrderId: this.detailData.id,
            skip: 0,
            count: -1,
        });
        if (this.data.data && this.data.data.length > 0) {
            // (this.$refs.Trajectory as any).setPoint(this.data.data, this.detailData.carCode);
            this.activities = [];
            console.log('datas-->', this.data);
            this.data.data.sort(function (a, b) {
                return b.locationTime < a.locationTime ? -1 : 1;
            });
            this.data.data.forEach((item, index) => {
                if (index == 0) {
                    this.activities.push({
                        content: item.address,
                        //timestamp: item.locationTime == '0001-01-01 00:00:00' || !item.locationTime ? item.locationTime : item.locationTime,
                        timestamp: item.locationTime,
                        type: '',
                        color: '#0bbd87',
                        longitude: item.longitude,
                        latitude: item.latitude,
                    });
                } else {
                    this.activities.push({
                        content: item.address,
                        //timestamp: item.bdnpTime == '0001-01-01 00:00:00' || !item.bdnpTime ? item.creationTime : item.bdnpTime,
                        timestamp: item.locationTime,
                        type: '',
                        longitude: item.longitude,
                        latitude: item.latitude,
                    });
                }
            });
        }
    }

    public async initActivity() {
        // this.data = await Order.GetLocationPageResult({ id: this.id });
        // let res = await LocationApi.GetLBSLocationState({
        //     phone: this.data.driverPhone,
        // });
        // this.isRegister = res.isRegister;
        // this.activities = [];
        // this.data.locations.sort(function (a, b) {
        //     return b.creationTime < a.creationTime ? -1 : 1;
        // });
        // this.data.locations.forEach((item, index) => {
        //     if (index == 0) {
        //         this.activities.push({
        //             content: item.area,
        //             timestamp: item.bdnpTime == '0001-01-01 00:00:00' || !item.bdnpTime ? item.creationTime : item.bdnpTime,
        //             type: '',
        //             color: '#0bbd87',
        //         });

        //     } else {
        //         this.activities.push({
        //             content: item.area,
        //             timestamp: item.bdnpTime == '0001-01-01 00:00:00' || !item.bdnpTime ? item.creationTime : item.bdnpTime,
        //             type: '',
        //         });

        //     }
        // });
        this.data = await WayBill.getHistoryLocation({
            carrierOrderId: this.detailData.id,
            skip: 0,
            count: -1,
        });
        // (this.$refs.Trajectory as any).setPoint(this.data.data, this.detailData.carCode);
        let res = await WayBill.getLbsStatus({
            phone: this.detailData.driverPhone,
        });
        this.isRegister = res.isRegister;
        this.activities = [];
        console.log('datas-->', this.data);
        this.data.data.sort(function (a, b) {
            return b.locationTime < a.locationTime ? -1 : 1;
        });
        this.data.data.forEach((item, index) => {
            if (index == 0) {
                this.activities.push({
                    content: item.address,
                    //timestamp: item.locationTime == '0001-01-01 00:00:00' || !item.locationTime ? item.locationTime : item.locationTime,
                    timestamp: item.locationTime,
                    type: '',
                    color: '#0bbd87',
                    longitude: item.longitude,
                    latitude: item.latitude,
                });
            } else {
                this.activities.push({
                    content: item.address,
                    //timestamp: item.bdnpTime == '0001-01-01 00:00:00' || !item.bdnpTime ? item.creationTime : item.bdnpTime,
                    timestamp: item.locationTime,
                    type: '',
                    longitude: item.longitude,
                    latitude: item.latitude,
                });
            }
        });
    }

    public save() {
        let goodsList = this.detailData.carrierOrderGoodsList.map((v) => {
            return { id: v.id, realQuantity: v.realQuantity, realGoodsUnit: v.realGoodsUnit };
        });
        let carrierAttList = this.detailData.carrierAttList.map((v) => {
            return { name: v.name, url: v.url };
        });
        let deliveryAttList = this.detailData.deliveryAttList.map((v) => {
            return { name: v.name, url: v.url };
        });
        console.log(goodsList, carrierAttList, deliveryAttList, {
            id: this.detailData.id,
            carId: this.detailData.carId,
            carCode: this.detailData.carCode,
            driverId: this.detailData.driverId,
            driverName: this.detailData.driverName,
            driverPhone: this.detailData.driverPhone,
            carLengthEnumStr: this.detailData.carLengthEnumStr,
            carLengthEnum: this.detailData.carLengthEnum,
            vehicleTypeEnumStr: this.detailData.vehicleTypeEnumStr,
            vehicleTypeEnum: this.detailData.vehicleTypeEnum,
            subLoadTime: this.detailData.subLoadTime,
            goodsList: goodsList,
            carrierAttList: carrierAttList,
            deliveryAttList: deliveryAttList,
        });
        WayBill.saveDfh({
            id: this.detailData.id,
            carId: this.detailData.carId,
            carCode: this.detailData.carCode,
            driverId: this.detailData.driverId,
            driverName: this.detailData.driverName,
            driverPhone: this.detailData.driverPhone,
            carLengthEnumStr: this.detailData.carLengthEnumStr,
            carLengthEnum: this.detailData.carLengthEnum,
            vehicleTypeEnumStr: this.detailData.vehicleTypeEnumStr,
            vehicleTypeEnum: this.detailData.vehicleTypeEnum,
            subLoadTime: this.detailData.subLoadTime,
            goodsList: goodsList,
            carrierAttList: carrierAttList,
            deliveryAttList: deliveryAttList,
        }).then((res) => {
            this.$message.warning('保存成功!');
            this.$router.push('/WayBillManage');
        });
    }
    fh: any = {
        fhDate: '',
    };
    qrsdDialog: boolean = false;
    sd: any = {
        sdDate: '',
    };
    qrsd() {
        this.qrsdDialog = true;
        this.sd.sdDate = this.formatDate(new Date());
    }
    //确认送达
    tosd() {
        let carrierAttList = this.detailData.carrierAttList.map((v) => {
            return { name: v.name, url: v.url };
        });

        let arrivalAttList = this.detailData.arrivalAttList.map((v) => {
            return { name: v.name, url: v.url };
        });
        this.$refs['sdForm']['validate']((valid) => {
            if (valid) {
                WayBill.confirmSd({
                    id: this.detailData.id,
                    carrierAttList: carrierAttList,
                    receiptStatus: this.detailData.receiptStatus,
                    arrivalAttList: arrivalAttList,
                    realArrivalTime: this.sd.sdDate,
                })
                    .then((res) => {
                        console.log('goto 送达');
                        this.qrsdDialog = false;
                        this.$message.warning('运单已送达!');
                        this.$router.push('/WayBillManage');
                    })
                    .catch((err) => {
                        this.$message.warning('运单确认送达失败!');
                    });
            }
        });
    }
    //删除费用
   public dialogConfigdel = {
        title: '',
        show: false,
    };
    confirmClosedel() {
        this.dialogConfigdel = {
            title: '',
            show: false,
        };
    }
    delfy(feeType,value) {
        this.feeType = feeType;
        this.selectionRow = value;
        console.log('delfy-->',value);
          this.dialogConfigdel = {
            title: '删除费用',
            show: true,
        };        
    }
    confirmOkdel(){
        if(this.feeType == 'a'){
            WayBill.delYf(this.selectionRow.id).then(res=>{
                this.dialogConfigdel = {
                    title: '',
                    show: false,
                };  
                this.$message.warning('删除成功!');
                WayBill.getyffeelist(this.detailData.id).then(res=>{
                    console.log('费用',res);
                    this.yffeelist = res.data;
                    this.yftotal = res.total;
                    this.totalyfAmount = res.totalAmount;
                })
            })
        }else{
            WayBill.delYs(this.selectionRow.id).then(res=>{
                this.dialogConfigdel = {
                    title: '',
                    show: false,
                };  
                this.$message.warning('删除成功!');
                WayBill.getysfeelist(this.detailData.id).then(res=>{
                    console.log('费用',res);
                    this.ysfeelist = res.data;
                    this.ystotal = res.total;
                    this.totalysAmount = res.totalAmount;
                })
            })
        }
        
    }
    //终结
   public dialogConfig3 = {
        title: '',
        show: false,
    };
    confirmClose3() {
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
    end() {
          this.dialogConfig3 = {
            title: '终结该运单',
            show: true,
        };
        // this.$confirm('确认终结该运单?', '运单终结', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // }).then((res) => {
        //     WayBill.endYd({ id: this.detailData.id }).then((res) => {
        //         console.log('end-->', res);
        //         this.$message.success('运单终结成功!');
        //         this.$router.push('/WayBillManage');
        //     });
        // });
    }
    confirmOk3(){
        WayBill.endYd({ id: this.detailData.id }).then((res) => {
                console.log('end-->', res);
                this.$message.success('运单终结成功!');
                this.$router.push('/WayBillManage');
            });
           this.dialogConfig3 = {
            title: '',
            show: false,
        };  
    }


    public formatDate(date) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();
        let second = date.getSeconds();
        return (
            year + '-' + month + '-' + this.formatTen(day) + ' ' + this.formatTen(hour) + ':' + this.formatTen(minute) + ':' + this.formatTen(second)
        );
    }
    public formatTen(num) {
        return num > 9 ? num + '' : '0' + num;
    }
    showTips(val, item) {
        console.log('clicktime->', val, item);
        // (this.$refs.Trajectory as any).triggerClick(val, item.longitude, item.latitude);
    }
    public total = 0;
    public paginationOptions = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public pageSizes = [10];
    public lastPageNum = 0;
    public pageSize: number = 10;
    public firstPageBtnDisabled = true;
    public lastPageBtnDisabled = false;
    public handleCurrentChange(val) {
        console.log('onPaginationChange', val);
        this.firstPageBtnDisabled = val === 1 ? true : false;
        this.lastPageBtnDisabled = val === Math.ceil(this.total / this.paginationOptions.count) ? true : false;
        this.paginationOptions.currentPage = val;
        this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        console.log('this.paginationOptions~', this.paginationOptions);
    }
    public handleSizeChange(val) {
        console.log('handleSizeChangeval' + JSON.stringify(val));

        this.paginationOptions.count = val;
        this.paginationOptions.currentPage = 1;
        this.handleCurrentChange(this.paginationOptions.currentPage);
        if (Math.ceil(this.total / val) < this.paginationOptions.currentPage) {
            this.paginationOptions.skip = 0;
        } else {
            this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        }
    }

    public paginationOptions1 = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public pageSizes1 = [10];
    public lastPageNum1 = 0;
    public pageSize1: number = 10;
    public firstPageBtnDisabled1 = true;
    public lastPageBtnDisabled1 = false;
    public handleCurrentChange1(val) {
        console.log('onPaginationChange', val);
        this.firstPageBtnDisabled1 = val === 1 ? true : false;
        this.lastPageBtnDisabled1 = val === Math.ceil(this.yftotal / this.paginationOptions1.count) ? true : false;
        this.paginationOptions1.currentPage = val;
        this.paginationOptions1.skip = (this.paginationOptions1.currentPage - 1) * this.paginationOptions1.count;
        console.log('this.paginationOptions~', this.paginationOptions1);
    }
    public handleSizeChange1(val) {
        console.log('handleSizeChangeval' + JSON.stringify(val));

        this.paginationOptions1.count = val;
        this.paginationOptions1.currentPage = 1;
        this.handleCurrentChange1(this.paginationOptions1.currentPage);
        if (Math.ceil(this.yftotal / val) < this.paginationOptions1.currentPage) {
            this.paginationOptions1.skip = 0;
        } else {
            this.paginationOptions1.skip = (this.paginationOptions1.currentPage - 1) * this.paginationOptions1.count;
        }
    }


     public paginationOptions2 = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public pageSizes2 = [10];
    public lastPageNum2 = 0;
    public pageSize2: number = 10;
    public firstPageBtnDisabled2 = true;
    public lastPageBtnDisabled2 = false;
    public handleCurrentChange2(val) {
        console.log('onPaginationChange', val);
        this.firstPageBtnDisabled2 = val === 1 ? true : false;
        this.lastPageBtnDisabled2 = val === Math.ceil(this.ystotal / this.paginationOptions2.count) ? true : false;
        this.paginationOptions2.currentPage = val;
        this.paginationOptions2.skip = (this.paginationOptions2.currentPage - 1) * this.paginationOptions2.count;
        console.log('this.paginationOptions~', this.paginationOptions2);
    }
    public handleSizeChange2(val) {
        console.log('handleSizeChangeval' + JSON.stringify(val));

        this.paginationOptions2.count = val;
        this.paginationOptions2.currentPage = 1;
        this.handleCurrentChange2(this.paginationOptions2.currentPage);
        if (Math.ceil(this.ystotal / val) < this.paginationOptions2.currentPage) {
            this.paginationOptions2.skip = 0;
        } else {
            this.paginationOptions2.skip = (this.paginationOptions2.currentPage - 1) * this.paginationOptions2.count;
        }
    }

    getStrWithSimonFromNum(num){
        let numstr = num.toString();
        let arr = numstr.split('.');
        if(arr.length>1){
            return  arr[0].toString().includes('-')?'-'+arr[0].toString().split('').reverse().join('').match(/\d{1,3}/g).join(',').split('').reverse().join('')+'.'+arr[1]:arr[0].toString().split('').reverse().join('').match(/\d{1,3}/g).join(',').split('').reverse().join('')+'.'+arr[1];
        }else{
            return  arr[0].toString().includes('-')?'-'+arr[0].toString().split('').reverse().join('').match(/\d{1,3}/g).join(',').split('').reverse().join(''):arr[0].toString().split('').reverse().join('').match(/\d{1,3}/g).join(',').split('').reverse().join('');
        }
    }
    handlweight(e, index) {
        e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,2})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,2})?/)[0] : '';
        this.planWeightForm.totalRealQuantity = e.target.value;
    }
    public confirmDeliveryDialog:boolean = false;

    public deliveryForm: any = {
        deliveryTime: ''
    }

    confirmDeliveryBtn(){
        (this.$refs['planWeightForm'] as any)['validate']((valid) => {
            if (valid) {
                this.confirmDeliveryDialog = true;
                this.deliveryForm.deliveryTime = this.formatDate(new Date());
            }
        });
       
    }
    confirmDeliveryClose(){
        (this.$refs.deliveryForm as any).resetFields();
        this.confirmDeliveryDialog = false;
    }

    /**确认发货 */
    confirmDelivery(){
        WayBill.confirmDelivery({
            id:this.detailData.id,
            realDeliveryTime: this.deliveryForm.deliveryTime,
            totalRealQuantity: this.planWeightForm.totalRealQuantity
        }).then(res=>{
              this.$message.success('运单已发货！');
              this.confirmDeliveryDialog = false;
              this.$router.push('/WayBillManage'); 
        })
    }
}
